import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	pageHeading: {
		id: 'portfolio-3-dependency-settings.ui.page-heading',
		defaultMessage: 'Dependency Settings',
		description: 'The heading for the dependency settings page.',
	},
});
